module.exports = __webpack_public_path__ + "img/footer_image.eb54b674.svg";